import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import '../../../pages/staffing-page/d-timekeeping-review';
import type { TimeBalanceSummaryData } from '../summary-view';

/**
 * Time balance summary component (Plusstid og avspasering)
 * Wraps d-timekeeping-review from staffing page
 */
@customElement('d-time-balance-summary')
export class DTimeBalanceSummary extends LitElement {
  @property({ type: Object })
  data!: TimeBalanceSummaryData;
  @property({ type: Number })
  contentStickyTop = 0;
  @property({ type: Boolean })
  sortByGroup = false;

  render() {
    return html`
      <d-timekeeping-review
        .sortByGroup=${this.sortByGroup}
        .employeeGroups=${this.data.employeeGroups}
        .employeesWithPeriods=${this.data.employeesWithPeriods}
        .defaultDate=${this.data.defaultDate}
        .currentUserHasAccess=${true}
        .contentStickyTop=${this.contentStickyTop}
        .timekeepingBeforeEmploymentStartWarning=${this.data.timekeepingBeforeEmploymentStartWarning}
      >
      </d-timekeeping-review>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'd-time-balance-summary': DTimeBalanceSummary;
  }
}
